import React from 'react';
import { typographyBody1, typographyBody2 } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { INPUT_SIZES } from '../constants';

const StyledBaseInputPrefixSuffix = styled.span`
  ${({ theme }) => typographyBody1(theme)}
  align-items: center;
  box-sizing: border-box;
  color: ${({ $isDisabled, theme }) =>
    $isDisabled ? theme.color.text.light.disabled.value : theme.color.text.light.primary.value};
  display: flex;
  flex-shrink: 0;
  overflow: hidden;
  ${({ $size, theme }) =>
    $size === INPUT_SIZES.LARGE &&
    css`
      ${typographyBody2(theme)}
      color: ${theme.color.text.light.primary.value};
    `}
`;

const BaseInputPrefixSuffix = ({
  dataTestId = undefined,
  isDisabled = false,
  size = INPUT_SIZES.STANDARD,
  ...props
}) => <StyledBaseInputPrefixSuffix data-testid={dataTestId} $isDisabled={isDisabled} $size={size} {...props} />;

BaseInputPrefixSuffix.propTypes = {
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, changes visual appearance */
  isDisabled: PropTypes.bool,
  /** Set the size of the input */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),
};

export { BaseInputPrefixSuffix };
